import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class CreateSectionGroupAdminService {

  constructor(
    private httpClient: HttpClient,
    private common: DatabaseCacheService
  ) { }

  createSectionGroupAdmin(sectionGroupId, postBody) {

    var httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  

    return this.httpClient.post(`${apiConfig.uri}/sectionGroups/${sectionGroupId}/admins`, postBody, httpOptions);
  }

}
